export enum CreditApplicationDashboardStatus {
  ActionNeeded = 'actionNeeded',
  Expired = 'expired',
  InReview = 'inReview',
  Incomplete = 'incomplete',
  AccountCreated = 'accountCreated',
  Declined = 'declined',
}
